<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
	export default {
		name: 'app'
	}
</script>

<style>
  body, html {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0 auto;
  }

  a {
    text-decoration: none;
    color: #15bde5;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue